import {queryParamInputOption as queryParamOptionFromCTA} from 'hec/builder/blocks/cta'

export const mockCustomerData = {
    email: 'rgoh@pixelmedia.com',
    isGuest: false,
    isRegistered: true,
    c_acLoyaltyTier: 'Gold'
}

export const perksAndRewardsSectionStateMap = {
    LOGGED_OUT: 'loggedOut',
    NOT_ENROLLED: 'notEnrolled',
    ENROLLED_WITH_NO_POINTS: 'enrolledWithNoPoints',
    ENROLLED_WITH_POINTS: 'enrolledWithPoints'
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const {showIf, ...queryParamInputOption} = queryParamOptionFromCTA

export const generateSubfields = () => {
    return Object.values(perksAndRewardsSectionStateMap).map((userState) => {
        const includePrompt = userState !== perksAndRewardsSectionStateMap.ENROLLED_WITH_POINTS

        // Base subfields
        const subFields = [
            ...(includePrompt ? [{name: 'prompt', type: 'string'}] : []),
            {
                name: 'ctaLink',
                type: 'reference',
                model: 'page',
                required: true
            },
            queryParamInputOption,
            {name: 'ctaText', type: 'string', required: true}
        ]

        // Add enum field only for LOGGED_OUT
        if (userState === perksAndRewardsSectionStateMap.LOGGED_OUT) {
            subFields.push({
                name: 'ctaMode',
                type: 'string',
                enum: ['drawer', 'link'],
                defaultValue: 'drawer',
                helperText: 'Choose whether to show a login drawer or a link when logged out.'
            })
        }

        return {
            name: userState,
            type: 'object',
            subFields,
            required: true
        }
    })
}
